module.exports = __webpack_public_path__ + "img/x5.ce7d549b.jpg";